import { Avatar, Box, Card, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { firestore } from '../../../../../contexts/FirebaseContext';

function Section5({ dataUser }) {
  const [dataHostUser, setDataHostUser] = useState({});

  console.log(dataHostUser);

  useEffect(() => {
    async function getHostUser() {
      const res = await firestore
        .collection('users')
        .doc(dataUser.hostUser)
        .onSnapshot((doc) => {
          setDataHostUser(doc.data());
        });
    }
    if (dataUser.hostUser) {
      getHostUser();
    }
  }, [dataUser.hostUser]);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Card
        sx={{
          padding: '15px',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          alignItems: 'center'
        }}
      >
        <Avatar alt={dataHostUser?.displayName} src={dataHostUser?.photoURL} />
        <Typography variant="subtitle2" noWrap>
          {dataHostUser?.displayName}
        </Typography>
        <Typography variant="subtitle2" noWrap>
          {dataHostUser?.email}
        </Typography>
      </Card>
    </Box>
  );
}

export default Section5;
